// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "./js/cbk-theme/" + {"41959":"cbk-theme.discount-request.plugin","44239":"cbk-theme.listing-sort.plugin","85263":"cbk-theme.mixed.plugin"}[chunkId] + "." + {"41959":"ae9a07","44239":"15a130","85263":"0740f3"}[chunkId] + ".js";
};